
import React from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
// import Banner from '../../common/Banner/Banner';
// import MapsComponent from '../../common/maps/MapsComponent';
import ContactSection from '../../components/contact/component/ContactSectionComponent';

const headerTags = {
    title: 'Contato - Envie sua mensagem ou descubra uma música', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta: {
        description: 'Deixa sua mensagem, peça uma música ou descubra o horário em que tocou o seu artista favorito. Fale conosco por telefone ou WhatsApp!',
        keywords: 'entre em contato, fale conosco, mensagem, envie uma mensagem, telefone, e-mail, whats, whatsapp, como chegar na antena 1, endereço, informações',
        'og:title': 'Contato - Envie sua mensagem ou descubra uma música',
        'og:description': 'Deixa sua mensagem, peça uma música ou descubra o horário em que tocou o seu artista favorito. Fale conosco por telefone ou WhatsApp!',
    },
};

// Banners
// const bannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-contact-multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };

const Contato = () => (
    <div className="pageWrapper tw-container tw-mx-auto tw-px-5">
        <HeaderTags title={headerTags.title} meta={headerTags.meta} />
        <ContactSection />
        {/* <MapsComponent isStreetView={false} /> */}

        {/* <Banner key={bannerConfig.adUnit} config={bannerConfig} /> */}
    </div>
);

export default Contato;
